import { UserActions } from '@next/core-lib/user';
import { createReducer, on } from '@ngrx/store';

import { CowState } from '../../models/cow.model';
import * as CowActions from '../actions/cow.actions';

export const initialState: CowState = {
  cow: null,
};

export const cowReducer = createReducer<CowState>(
  initialState,
  on(CowActions.loadCowSuccess, (state, { cow }) => ({
    ...state,
    cow,
  })),
  on(UserActions.relationshipSelected, () => initialState),
);
